module.exports = __webpack_public_path__ + "static/media/transportify-page-not-found.801934af.png";